// The definition of each budget term, written once. TRACKER_TEXT (Budget Tracker) and DASHBOARD_TEXT (SaH Dashboard)
// are built from these; the Confluence pages mirror the composed text, so change both together.
export const BUDGET_TERMS = {
  available: { includes: 'care management and any supplements that add to it' },
  allocated: {
    lineValue:
      'A service line is quantity times rate times the occurrences in its dates, at the public holiday rate if the ' +
      'line includes public holidays.',
  },
  booked: {
    occurrences: 'A repeating appointment counts every occurrence, including future ones.',
    cancellations: 'A chargeable cancellation counts the minutes the client was charged.',
  },
  claimed: {
    value: "at the amount claimed: the full price including the client's contribution, excluding GST",
    ignored: 'Claim lines marked ignored are not counted.',
  },
  careManagement: {
    allowance:
      "10% of the client's gross funding: the budget total times 0.1 when the total includes care management, or the " +
      'total divided by 9 when it was entered without it.',
    used:
      "Every care management appointment in the budget's dates, booked or claimed: single appointments and every " +
      'occurrence of a repeating appointment, future ones included, valued like any other appointment: at its budget ' +
      "line's rate, or the price plan rate for its time band when the budget has no line for it, and at the amount " +
      'claimed once claimed.',
  },
  remaining: { formula: 'Allocated minus Booked minus Claimed' },
  unallocated: { formula: 'Available minus Allocated' },
  allocationRate: { formula: 'Allocated divided by Available' },
  utilisationRate: { formula: 'Booked plus Claimed, divided by Allocated' },
  overUtilised: {
    rule: 'Above 100% the budget is over-utilised: more is booked and claimed than it allocated.',
    notOverspent:
      "This compares with Allocated, what the budget agreed. Overspent compares with Available, the client's funding.",
  },
  // Added to the warnings about the agreed budget (TAV-3482)
  prompts: { updateBudget: 'You may wish to update the budget.' },
  // The client's Commonwealth unspent funds (HCP), shown for reference only (TAV-3482)
  hcp: {
    referenceOnly:
      'This is for reference only. We do not take any HCP Unspent funds into account for any calculations.',
  },
  // Care management by worker (TAV-3482): the calculation in plain English, for the info text. Both figures are over the
  // whole quarter, not so far.
  cmByWorker: {
    calculation:
      'Average CM Working Hours Per Working Day is Total CM Hours divided by Working Days. Total CM Hours is the ' +
      "worker's care management appointments dated in the quarter, booked or claimed, including ones still to come, " +
      'cancelled ones left out, added up in hours. Working Days is every Monday to Friday in the quarter. The result ' +
      'is an estimated average, not a target.',
    // The column tooltip: one short line, the (i) info keeps the full calculation above (TAV-3482)
    formula: 'An estimate: CM hours this quarter divided by its Monday to Friday working days.',
  },
} as const;
